var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { goBack, navigateToWithParams, } from '@popup/multichain/actions/navigation.actions';
import { refreshActiveAccount } from '@popup/steem/actions/active-account.actions';
import { WitnessGlobalInformationComponent } from '@popup/steem/pages/app-container/home/governance/my-witness-tab/witness-information/witness-global-information/witness-global-information.component';
import { WitnessInformationParametersComponent } from '@popup/steem/pages/app-container/home/governance/my-witness-tab/witness-information/witness-information-parameters/witness-information-parameters.component';
import BlockchainTransactionUtils from '@popup/steem/utils/blockchain.utils';
import WitnessUtils, { WITNESS_DISABLED_KEY, } from '@popup/steem/utils/witness.utils';
import { Screen } from '@reference-data/screen.enum';
import { KeychainKeyTypes, KeychainKeyTypesLC, } from '@steempro/steem-keychain-commons';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import 'react-tabs/style/react-tabs.scss';
import { ButtonType } from 'src/common-ui/button/button.component';
import { OperationButtonComponent } from 'src/common-ui/button/operation-button.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import { SlidingBarComponent } from 'src/common-ui/switch-bar/sliding-bar.component';
var WitnessInfoScreen;
(function (WitnessInfoScreen) {
    WitnessInfoScreen["INFO"] = "INFO";
    WitnessInfoScreen["PARAMS"] = "PARAMS";
})(WitnessInfoScreen || (WitnessInfoScreen = {}));
const WitnessInformation = ({ activeAccount, witnessInfo, ranking, setEditMode, navigateToWithParams, addToLoadingList, setErrorMessage, setSuccessMessage, removeFromLoadingList, refreshActiveAccount, goBack, }) => {
    const [selectedScreen, setSelectedScreen] = useState(WitnessInfoScreen.INFO);
    const [witnessRanking, setWitnessRanking] = useState();
    const [lastSigningKey, setLastSigningKey] = useState(null);
    useEffect(() => {
        initLastSigningKey();
        setWitnessRanking(ranking.filter((witness) => witness.owner === activeAccount.name)[0]);
    }, [ranking]);
    const initLastSigningKey = () => __awaiter(void 0, void 0, void 0, function* () {
        setLastSigningKey(yield WitnessUtils.getLastSigningKeyForWitness(activeAccount.name));
    });
    const gotoNextPage = () => {
        setEditMode(true);
    };
    const disableWitness = () => {
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: KeychainKeyTypes.active,
            fields: [],
            message: getMessage('popup_html_disable_witness_account_confirmation_message', [activeAccount.name]),
            title: `popup_html_disable_witness`,
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                addToLoadingList('html_popup_update_witness_operation');
                try {
                    yield WitnessUtils.saveLastSigningKeyForWitness(activeAccount.name, witnessInfo.signingKey);
                    const success = yield WitnessUtils.updateWitnessParameters(activeAccount.name, {
                        accountCreationFee: witnessInfo.params.accountCreationFee,
                        maximumBlockSize: witnessInfo.params.maximumBlockSize,
                        sbdInterestRate: witnessInfo.params.sbdInterestRate,
                        signingKey: WITNESS_DISABLED_KEY,
                        url: witnessInfo.url,
                    }, activeAccount.keys.active, options);
                    addToLoadingList('html_popup_confirm_transaction_operation');
                    removeFromLoadingList('html_popup_update_witness_operation');
                    yield BlockchainTransactionUtils.delayRefresh();
                    removeFromLoadingList('html_popup_confirm_transaction_operation');
                    refreshActiveAccount();
                    if (success) {
                        goBack();
                        if (success.isUsingMultisig) {
                            setSuccessMessage('multisig_transaction_sent_to_signers');
                        }
                        else
                            setSuccessMessage('popup_success_witness_account_update');
                    }
                    else {
                        setErrorMessage('popup_error_witness_account_update', [
                            `${activeAccount.name}`,
                        ]);
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                    removeFromLoadingList('html_popup_update_witness_operation');
                    removeFromLoadingList('html_popup_confirm_transaction_operation');
                }
                finally {
                    removeFromLoadingList('html_popup_confirm_transaction_operation');
                    removeFromLoadingList('html_popup_confirm_transaction_operation');
                }
            }),
        });
    };
    const enableWitness = () => {
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: KeychainKeyTypes.active,
            message: getMessage('popup_html_disable_witness_account_confirmation_message', [activeAccount.name]),
            title: `popup_html_enable_witness`,
            fields: [
                {
                    label: 'popup_html_witness_information_signing_key_label',
                    value: lastSigningKey,
                    valueClassName: 'xs-font',
                },
            ],
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                addToLoadingList('html_popup_update_witness_operation');
                try {
                    const success = yield WitnessUtils.updateWitnessParameters(activeAccount.name, {
                        accountCreationFee: witnessInfo.params.accountCreationFee,
                        maximumBlockSize: witnessInfo.params.maximumBlockSize,
                        sbdInterestRate: witnessInfo.params.sbdInterestRate,
                        signingKey: lastSigningKey,
                        url: witnessInfo.url,
                    }, activeAccount.keys.active, options);
                    addToLoadingList('html_popup_confirm_transaction_operation');
                    removeFromLoadingList('html_popup_update_witness_operation');
                    yield BlockchainTransactionUtils.delayRefresh();
                    removeFromLoadingList('html_popup_confirm_transaction_operation');
                    refreshActiveAccount();
                    if (success) {
                        goBack();
                        if (success.isUsingMultisig) {
                            setSuccessMessage('multisig_transaction_sent_to_signers');
                        }
                        else
                            setSuccessMessage('popup_success_witness_account_update');
                    }
                    else {
                        setErrorMessage('popup_error_witness_account_update', [
                            `${activeAccount.name}`,
                        ]);
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                    removeFromLoadingList('html_popup_update_witness_operation');
                    removeFromLoadingList('html_popup_confirm_transaction_operation');
                }
                finally {
                    removeFromLoadingList('html_popup_confirm_transaction_operation');
                    removeFromLoadingList('html_popup_confirm_transaction_operation');
                }
            }),
        });
    };
    const changeSelectedScreen = (selectedValue) => {
        setSelectedScreen(selectedValue);
    };
    return (React.createElement("div", { className: "witness-information" },
        React.createElement("div", { className: "top-panel" },
            React.createElement(SlidingBarComponent, { dataTestId: "witness", id: "witness", onChange: changeSelectedScreen, selectedValue: selectedScreen, values: [
                    {
                        value: WitnessInfoScreen.INFO,
                        label: 'html_popup_witness_information_info_label',
                    },
                    {
                        value: WitnessInfoScreen.PARAMS,
                        label: 'html_popup_witness_information_params_label',
                    },
                ] })),
        React.createElement("div", { className: "witness-profile-container" },
            React.createElement("div", { className: "witness-profile" },
                React.createElement("img", { className: "witness-image", src: `https://steemitimages.com/u/${activeAccount.name}/avatar`, onError: (e) => {
                        e.target.onError = null;
                        e.target.src = '/assets/images/accounts.png';
                    } }),
                React.createElement("div", { className: "info-container" },
                    React.createElement("div", { className: "witness-name" },
                        "@",
                        activeAccount.name))),
            witnessInfo.isDisabled && (React.createElement(SVGIcon, { className: "witness-disabled", icon: SVGIcons.GOVERNANCE_MY_WITNESS_DEACTIVATED, tooltipMessage: "popup_html_witness_information_witness_disabled_text", tooltipPosition: "right" }))),
        selectedScreen === WitnessInfoScreen.INFO && witnessRanking && (React.createElement(WitnessGlobalInformationComponent, { witnessInfo: witnessInfo })),
        selectedScreen === WitnessInfoScreen.PARAMS && (React.createElement(React.Fragment, null,
            React.createElement(WitnessInformationParametersComponent, { witnessInfo: witnessInfo }),
            React.createElement("div", { className: "fill-space" }),
            React.createElement("div", { className: "bottom-panel" },
                React.createElement("div", { className: "buttons-container" },
                    React.createElement(OperationButtonComponent, { requiredKey: KeychainKeyTypesLC.active, onClick: () => gotoNextPage(), label: 'html_popup_button_edit_label', additionalClass: "padding-top", type: ButtonType.ALTERNATIVE }),
                    !witnessInfo.isDisabled && (React.createElement(OperationButtonComponent, { requiredKey: KeychainKeyTypesLC.active, onClick: () => disableWitness(), label: 'popup_html_disable_witness', type: ButtonType.IMPORTANT })),
                    witnessInfo.isDisabled && lastSigningKey && (React.createElement(OperationButtonComponent, { requiredKey: KeychainKeyTypesLC.active, onClick: () => enableWitness(), label: 'popup_html_enable_witness', type: ButtonType.IMPORTANT }))))))));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
    };
};
const connector = connect(mapStateToProps, {
    navigateToWithParams,
    addToLoadingList,
    setErrorMessage,
    setSuccessMessage,
    removeFromLoadingList,
    refreshActiveAccount,
    goBack,
});
export const WitnessInformationComponent = connector(WitnessInformation);
